import LifecycleServices from 'pluginServices/services/LifecycleServices';
import { INTERACTIVE } from 'services/ActivityService/elementTypes';

export const getComponentUsage = async (config) => {
  if (!config?.components?.length) {
    return { activeComponents: [], unusedComponents: [] };
  }

  const searchString = [
    config.stage,
    config.rightPanelPlugin,
    config.introSection?.stage,
  ]
    .filter(Boolean) // remove undefined/null/falsey
    .map(JSON.stringify)
    .join('');

  const activeComponents = [];
  const unusedComponents = [];

  for (const component of config.components) {
    if (!component) continue;
    const isUsed =
      searchString.includes(component.localRef ?? '') ||
      searchString.includes(component.itemId ?? '');

    if (isUsed) activeComponents.push(component);
    else unusedComponents.push(component);
  }

  return { activeComponents, unusedComponents };
};

export const deleteUnusedComponents = async (interactiveId, components) => {
  if (!interactiveId || !components?.length) return;

  const lifecycleService = LifecycleServices.build({
    context: null,
    id: interactiveId,
    coursewareType: INTERACTIVE,
  });

  await Promise.all(
    components.map(async (component) => {
      if (!component?.itemId) return;
      try {
        await lifecycleService.deleteChild(component.itemId);
        // eslint-disable-next-line no-console
        console.log(`Deleted unused component: ${component.itemId}`);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(`Error while deleting unused component: ${component.itemId}`);
      }
    })
  );
};
